import React, { useState, useEffect } from "react";
import TvaButton from "./TvaButton";
import FrequenceButton from "./FrequenceButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faMoneyBill,
  faPencilAlt,
  faCheckCircle,
  faCheck,
  faRemove,
  faScroll
} from "@fortawesome/free-solid-svg-icons";
import Creatable from "react-select/creatable";
import {
  copyToClipboard,
  notify,
  selectStyles,
  selectTheme
} from "../../generic";
import {
  Item,
  Menu,
  Separator,
  Submenu,
  useContextMenu
} from "react-contexify";
import {
  displayCurrency,
  displayFloatAmount
} from "../../../services/functions";

function displayAmount(amount, currencyCode) {
  let montant = (
    <span className={`amount ${amount > 0 ? "positive" : "negative"}`}>
      {displayFloatAmount(amount)} {displayCurrency(currencyCode)}
    </span>
  );

  return montant;
}

function TransactionFournisseur({
  fournisseurs,
  createLabelAction,
  utilisateurId,
  entreprise,
  transaction = {},
  refetchAction,
  newlyCreatedFournisseur
}) {
  const [selectedFournisseur, setSelectedFournisseur] = useState(null);
  const [editing, setEditing] = useState(false);
  let contentFournisseur = "Aucun";
  const {} = transaction;
  if (!fournisseur) contentFournisseur = "Aucun";
  if (selectedFournisseur)
    contentFournisseur = selectedFournisseur.label || "Aucun";

  const {
    name,
    cleanDescription,
    montant,
    frequencyType,
    referenceDate,
    fournisseur,
    parent,
    splitted
  } = transaction;

  const handleUpdateFournisseur = object => {
    setEditing(false);
    setSelectedFournisseur({ label: object.name, value: object.value });
    createLabelAction({ ...object });
  };
  const matchingFournisseur = fournisseurs.filter(
    fo => fo.value === fournisseur
  );

  const display = () => {
    if (!editing)
      return (
        <span
          className="selectFournisseur"
          onClick={() => {
            setEditing(true);
            setSelectedFournisseur(matchingFournisseur);
          }}
        >
          {matchingFournisseur[0]
            ? matchingFournisseur[0].label
            : contentFournisseur}
          <span className="icon">
            <FontAwesomeIcon icon={faPencilAlt} />
          </span>
        </span>
      );

    return (
      <Creatable
        options={fournisseurs}
        placeholder={"Aucun"}
        noOptionsMessage={"Aucun fournisseur"}
        value={matchingFournisseur[0]}
        theme={theme => selectTheme(theme)}
        onMenuClose={() => setEditing(false)}
        styles={{
          ...selectStyles,
          container: () => ({
            ...selectStyles.container,
            zIndex: 9999,
            maxHeight: 400
          })
        }}
        onCreateOption={e =>
          handleUpdateFournisseur({
            utilisateurId,
            name: e,
            fournisseurId: -1,
            cleanDescription,
            entreprise,
            montant,
            frequencyType,
            referenceDate: transaction.date,
            refetch: refetchAction
          })
        }
        onChange={e => {
          matchingFournisseur[0] = { label: "test", value: "test" };

          handleUpdateFournisseur({
            utilisateurId,
            name: e.label,
            fournisseurId: e.value,
            cleanDescription,
            entreprise,
            montant,
            refetch: refetchAction,
            frequencyType,
            referenceDate: transaction.date
          });
        }}
      />
    );
  };
  return (
    <div className={`colFournisseur ${editing ? "editing" : ""}`}>
      <label>Fournisseur/client</label>
      <span className="fournisseur">{display()}</span>
    </div>
  );
}

function TransactionDescription({
  refetchAction,
  utilisateurId,
  entreprise,
  transaction,
  fournisseurs,
  addedFournisseurs = [],
  selectedFournisseur = {},
  updateTransactionCategorieAction,
  plan = { categories: [] }
}) {
  const [buttonActive, setButtonActive] = useState(false); // correspond à un identfiant de compte, sinon null
  const [hovering, setHovering] = useState(false); // correspond à un identfiant de compte, sinon null

  const {
    name,
    cleanDescription,
    bankDescription,
    montant,
    frequencyType,
    referenceDate,
    fournisseur,
    produitId,
    produitName,
    isProfit
  } = transaction;

  const { frequenceId, id: transactionId } = transaction;

  let shortenDescription = cleanDescription.substring(0, 40);
  let categorie;
  let longDescription;

  const PLAN_MENU_ID = `planMenu-${transactionId}`;

  const { show } = useContextMenu({
    id: PLAN_MENU_ID
  });

  const handleItemClick = ({ data }) => {
    updateTransactionCategorieAction({
      utilisateurId,
      produitId: data,
      frequenceId,
      refetch: refetchAction
    });
  };

  const displayMenu = e => {
    if (fournisseur) {
      show(e, {
        position: {
          x: e.pageX,
          y: e.pageY
        }
      });
      setButtonActive(true);
    } else {
      notify(
        "error",
        "Vous devez spécifier un fournisseur/client pour classer cette transaction"
      );
    }
  };

  const handleContextMenuAction = e => {
    console.log({ e });
    handleItemClick({
      ...e,
      addedFournisseurs,
      selectedFournisseur,
      fournisseurs
    });
  };

  let isProfitIcon = null;
  if (!isProfit && produitId) {
    isProfitIcon = (
      <FontAwesomeIcon icon={faScroll} size={"xs"} color="#ec787f" />
    );
  } else if (isProfit) {
    isProfitIcon = (
      <FontAwesomeIcon icon={faMoneyBill} size={"xs"} color="#677F62" />
    );
  }

  const planMenu = (
    <Menu id={PLAN_MENU_ID} onHidden={() => setButtonActive(false)}>
      <Submenu
        label={
          <>
            <FontAwesomeIcon icon={faMoneyBill} size={"sm"} color="#677F62" />
            &nbsp;Profit
          </>
        }
        arrow={<FontAwesomeIcon icon={faChevronRight} />}
      >
        {plan.categories
          .filter(it => it.profit)
          .map(
            ({
              id: categorieId,
              name: categorieName,
              profit,
              produits = []
            }) => (
              <Submenu
                label={categorieName}
                arrow={<FontAwesomeIcon icon={faChevronRight} />}
              >
                {produits.map(({ id: produitId, name: produitName }) => (
                  <Item
                    data={produitId}
                    onClick={e => handleContextMenuAction(e)}
                  >
                    {produitName}
                  </Item>
                ))}
              </Submenu>
            )
          )}
      </Submenu>
      <Submenu
        label={
          <>
            <FontAwesomeIcon icon={faScroll} size={"sm"} color="#ec787f" />
            &nbsp;Pertes
          </>
        }
        arrow={<FontAwesomeIcon icon={faChevronRight} />}
      >
        {plan.categories
          .filter(it => !it.profit)
          .map(
            ({
              id: categorieId,
              name: categorieName,
              profit,
              produits = []
            }) => (
              <Submenu
                label={categorieName}
                arrow={<FontAwesomeIcon icon={faChevronRight} />}
              >
                {produits.map(({ id: produitId, name: produitName }) => (
                  <Item
                    data={produitId}
                    onClick={e => handleContextMenuAction(e)}
                  >
                    {produitName}
                  </Item>
                ))}
              </Submenu>
            )
          )}
      </Submenu>
      {produitId && (
        <>
          <Separator />
          <Item data={null} onClick={e => handleContextMenuAction(e)}>
            <FontAwesomeIcon icon={faRemove} />
            &nbsp;Retirer
          </Item>
        </>
      )}
    </Menu>
  );

  if (cleanDescription.length > 40)
    shortenDescription = shortenDescription.trim() + "...";

  const descriptionClasses = ["description"];

  const overlay = (
    <div className={`inblock-overlay ${buttonActive ? "" : "hidden"}`}></div>
  );
  if (hovering) {
    descriptionClasses.push("hovering");
    shortenDescription = cleanDescription;
    longDescription = (
      <span className="longDescription">{bankDescription}</span>
    );
  } else {
    categorie = (
      <>
        {overlay}
        <span onClick={e => displayMenu(e)} className="category">
          {isProfitIcon} {produitName}
        </span>
        {planMenu}
      </>
    );
  }

  let hoveringTimeout;

  const delayHovering = () => {
    if (!hoveringTimeout)
      hoveringTimeout = setTimeout(() => setHovering(true), 1000);
  };

  const killHovering = () => {
    setHovering(false);
    clearTimeout(hoveringTimeout);
    hoveringTimeout = null;
  };

  return (
    <>
      <div
        onMouseMove={() => delayHovering()}
        onMouseEnter={() => delayHovering()}
        onMouseOut={() => killHovering()}
        onClick={() => hovering && copyToClipboard(bankDescription)}
        className={`sensitiveZone ${hovering ? "hovering" : ""}`}
      ></div>
      <div className={descriptionClasses.join(" ")}>
        {shortenDescription}
        {longDescription}
      </div>
      {categorie}
    </>
  );
}

function AmountInput({
  transactionId,
  utilisateurId,
  parentData,
  montant,
  tva = 20,
  updateTransaction,
  refetchAction,
  currency
}) {
  if (!parentData) return null;
  const [txAmount, setTxAmount] = useState(montant);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    setTxAmount(montant);
  }, [montant]);

  const handleKeyUp = e => {
    if (txAmount === 0) return;
    if (e.keyCode === 13) {
      setChanged(false);
      // La touche Entrée a été enfoncée, on exécute la fonction de validation
      updateTransaction({
        utilisateurId,
        tva,
        montant: parseFloat(txAmount),
        transactionId,
        refetch: refetchAction
      });
    }
  };

  const updateAmount = inputValue => {
    const value = inputValue.replace(",", ".");
    if (value === montant) return;
    if (isNaN(parseFloat(value)) || (parseFloat(value) <= 0 && value === "-")) {
      return;
    }

    if (!value) {
      setTxAmount(0);
      return;
    }
    console.log({ value });

    const { montant: montantMax } = parentData;
    if (
      ((montantMax > 0 && value >= montantMax) ||
        (montantMax < 0 && value <= montantMax)) &&
      value !== "-0"
    ) {
      notify(
        "error",
        "Le montant ne peut excéder le montant de la transaction parent"
      );
      return;
    }

    setChanged(true);
    setTxAmount(value);

    if (parseFloat(value) === 0) return;

    /*
    updateTransaction({
      utilisateurId,
      tva,
      montant: parseFloat(value),
      transactionId,
      refetch: refetchAction
    });*/
  };

  return (
    <div className="transAmountInput">
      {changed}
      <div className="currency">{displayCurrency(currency)}</div>
      <input
        type="text"
        placeholder="#"
        onKeyUp={handleKeyUp}
        onChange={({ target }) => updateAmount(target.value)}
        value={txAmount}
      />
      <div className={`confirmButton ${changed ? "" : "hidden"}`}>
        <FontAwesomeIcon icon={faCheck} />
      </div>
      <div className={`confirm ${changed ? "" : "hidden"}`}>
        Appuyez sur entrée pour valider
      </div>
    </div>
  );
}

function renderChildren(children = []) {
  if (!children.length) return null;

  return <ul className="children">{children}</ul>;
}

function Transaction({
  utilisateurId,
  transaction,
  dataPlan = {},
  updateFournisseur,
  updateTransaction,
  updateCategorie,
  addedFournisseurs = [],
  selectedFournisseur,
  entreprise,
  fournisseurs,
  refetch,
  children,
  child = false,
  parentData = null // transaction
}) {
  const { parent, splitted } = transaction;

  const transactionClasses = ["transaction"];
  if (splitted && children.length > 0) transactionClasses.push("splitted");

  return (
    <li className={transactionClasses.join(" ")}>
      <TransactionDescription
        plan={dataPlan.getPlan}
        updateTransactionCategorieAction={updateCategorie}
        entreprise={entreprise}
        utilisateurId={utilisateurId}
        transaction={transaction}
        fournisseurs={fournisseurs}
        refetchAction={refetch}
        addedFournisseurs={addedFournisseurs}
        selectedFournisseur={selectedFournisseur}
      />
      <TransactionFournisseur
        key={`txFo-${transaction.id}`}
        transaction={transaction}
        utilisateurId={utilisateurId}
        entreprise={entreprise}
        createLabelAction={updateFournisseur}
        fournisseurs={fournisseurs}
        refetchAction={refetch}
        addedFournisseurs={addedFournisseurs}
        selectedFournisseur={selectedFournisseur}
      />
      <AmountInput
        utilisateurId={utilisateurId}
        transactionId={transaction.id}
        tva={transaction.tva}
        parentData={parentData}
        montant={transaction.montant}
        currency={transaction.currencyCode}
        updateTransaction={updateTransaction}
        refetchAction={refetch}
      />
      <TvaButton
        fournisseurs={fournisseurs}
        utilisateurId={utilisateurId}
        entreprise={entreprise}
        transaction={transaction}
        updateFrequenceAction={updateFournisseur}
        refetchAction={refetch}
        addedFournisseurs={addedFournisseurs}
        updateTransaction={updateTransaction}
        selectedFournisseur={selectedFournisseur}
      />
      <FrequenceButton
        fournisseurs={fournisseurs}
        utilisateurId={utilisateurId}
        entreprise={entreprise}
        transaction={transaction}
        updateFrequenceAction={updateFournisseur}
        refetchAction={refetch}
        addedFournisseurs={addedFournisseurs}
        selectedFournisseur={selectedFournisseur}
      />
      {displayAmount(transaction.montant, transaction.currencyCode)}
      {renderChildren(children)}
      <div className="filler"></div>
    </li>
  );
}

export default Transaction;
